export default "__VITE_ASSET__IOtE86AR__"